import { MenuLinks } from '@/constants/menu'
import type { ViewUserDetailsResponse } from '@/helpers/api/WebApiClient'

const PRESS_RELEASE_SOURCE = 'pressrelease'

export const isPressReleaseUser = (userData?: ViewUserDetailsResponse | Record<string, never> | null) => {
	const registrationSource = 'registrationSource' in (userData ?? {}) ? userData?.registrationSource : undefined

	return (registrationSource ?? '').trim().toLowerCase() === PRESS_RELEASE_SOURCE
}

export const getPostLoginRedirectUrl = (defaultRedirectUrl: string, userData?: ViewUserDetailsResponse | Record<string, never> | null) => {
	if (isPressReleaseUser(userData)) {
		return MenuLinks.BetaWelcome
	}

	return defaultRedirectUrl
}
